import {
  Box,
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'
import TableLocal from '../../../../components/Table/TableLocal/TableLocal'
import { colors } from '../../../../utils/theme/styles'

const tradeColumns = [
  {
    Header: (props) => <Text {...props}>Sucursal</Text>,
    accessor: 'sSucursal',
    id: 'sSucursal',
  },
  {
    Header: (props) => <Text {...props}>Centro de Costo</Text>,
    accessor: 'sCentroCosto',
    id: 'sCentroCosto',
  },
  {
    Header: (props) => <Text {...props}>Rut</Text>,
    accessor: 'sRUT',
    id: 'sRUT',
  },
  {
    Header: (props) => <Text {...props}>Nombre</Text>,
    accessor: 'sNombre',
    id: 'sNombre',
  },
  {
    Header: (props) => <Text {...props}>Estado Socio</Text>,
    accessor: 'sEstadoSocio',
    id: 'sEstadoSocio',
  },
  {
    Header: (props) => <Text {...props}>Tarjeta</Text>,
    accessor: 'sTarjeta',
    id: 'sTarjeta',
  },
  {
    Header: (props) => <Text {...props}>Estado Tarjeta</Text>,
    accessor: 'sEstadoTarjeta',
    id: 'sEstadoTarjeta',
  },
  {
    Header: (props) => <Text {...props}>Saldo Tarjeta</Text>,
    accessor: 'sSaldo',
    id: 'sSaldo',
    type: 'currency',
  },
  {
    Header: (props) => <Text {...props}>Dirección</Text>,
    accessor: 'sDireccion',
    id: 'sDireccion',
  },
  {
    Header: (props) => <Text {...props}>Comuna</Text>,
    accessor: 'sComuna',
    id: 'sComuna',
  },
  {
    Header: (props) => <Text {...props}>Región</Text>,
    accessor: 'sRegion',
    id: 'sRegion',
  },
  {
    Header: (props) => <Text {...props}>Email</Text>,
    accessor: 'sEmail',
    id: 'sEmail',
  },
  {
    Header: (props) => <Text {...props}>Fecha Nacimiento</Text>,
    accessor: 'dNacimiento',
    id: 'dNacimiento',
  },
  {
    Header: (props) => <Text {...props}>Sexo</Text>,
    accessor: 'sSexo',
    id: 'sSexo',
  },
]
export default function PartnersListReport({ data }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button
        borderRadius={8}
        variant="ghost"
        onClick={onOpen}
        minHeight="56px"
        padding="0px 15px"
        backgroundColor="#fff"
        border="1px solid #D7D7D7"
      >
        <Box me={3}>
          <FontAwesomeIcon icon={faEye} />
        </Box>
        Ver informe
      </Button>

      <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bgColor={colors.secondary.base} color={colors.gray[50]}>
            Detalle Saldo de Colaboradores
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow="auto">
            <TableLocal
              data={data || []}
              columns={tradeColumns || []}
              tableStyles={{ overflow: 'auto' }}
            />
          </ModalBody>

          <ModalFooter w="100%">
            <Center w="100%">
              <Button w="324px" onClick={onClose}>
                Cerrar
              </Button>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

PartnersListReport.propTypes = {
  data: PropTypes.array,
}
